<homey-notification-dialog-content [title]="title" [closeButton]="closeButton()">
  <div>
    <img src="/assets/gift.png" alt="Gift icon" class="h-32 w-32 mx-auto my-4">
  </div>
  <div class="mb-6">
    <p>Complete your registration for automated Housing Lottery applications.</p>
  </div>
</homey-notification-dialog-content>
<ng-template #title>
  Special discount: <span class="text-orange-gradient">3&nbsp;months&nbsp;for&nbsp;$1/month</span>
</ng-template>

